import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Colors, CreditDetails } from 'Types';
import { clx } from 'Utils';
import { Card, Badge, FontAwesome } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';
import { SkeletonCommissionGroup } from '../skeleton/SkeletonCommissionGroup';

interface Props {
	credit: CreditDetails | undefined;
	isLoading: boolean;
}

export const CommissionGroup: FC<Props> = ({ credit, isLoading }) => {
	const { t } = useTranslation();

	return isLoading ? (
		<SkeletonCommissionGroup />
	) : (
		<Col>
			<Card className="h-100">
				<h6
					className={clx(
						styles.row,
						'd-flex align-items-center justify-content-between text-gray-3 fs-6 fw-400'
					)}>
					<span className={styles.rowLabel}>
						{t('label.commission-group')}
					</span>
					<div className="d-flex gap-2 align-items-center">
						<Badge
							color={
								credit?.commissionGroupInfo?.isPremium
									? Colors.premium
									: Colors.tertiary
							}
							className="gap-2">
							{credit?.commissionGroupInfo?.isPremium && (
								<FontAwesome icon={'medal'} size="lg" />
							)}
							{credit?.commissionGroupInfo?.isPremium
								? t('button.premium')
								: t('button.standard')}
						</Badge>
						<Badge
							color={
								credit?.commissionGroupInfo?.isActive
									? Colors.green
									: Colors.muted
							}
							className="gap-2">
							{credit?.commissionGroupInfo?.isActive
								? t('badge.active')
								: t('badge.inactive')}
						</Badge>
					</div>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.title')}
							</span>
							<span>
								{credit?.commissionGroupInfo?.title ?? '---'}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.is-premium')}
							</span>
							<span>
								{credit?.commissionGroupInfo?.isPremium
									? t('label.yes')
									: t('label.no')}
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
